import { RequestGalleryEntriesByCounty } from "../dtos/transmed/gallery";
import Server from "./index";

export default class TransmedGalleryServer extends Server {
  constructor() {
    super("/transmed_gallery.php");
  }

  public get(params: RequestGalleryEntriesByCounty): Promise<any> {
    return super.get(params);
  }
}
